import { CheckIcon, ClockIcon, XCircleIcon } from "@heroicons/react/outline";

import LoadingSpinner from "@/components/LoadingSpinner";
import { BasicTooltip } from "@/components/ui/Tooltip";

export enum CellStatus {
  COMPLETED = "COMPLETED",
  RUNNING = "RUNNING",
  QUEUED = "QUEUED",
  FAILED = "FAILED",
  LOADING = "LOADING",
}

export interface StatusIndicatorProps {
  status: CellStatus;
  icon?: React.ReactNode;
  showTooltip?: boolean;
  tooltipText?: string;
  className?: string;
}

const statusIcons = {
  [CellStatus.COMPLETED]: <CheckIcon className="h-4 w-4 text-green-500" />,
  [CellStatus.RUNNING]: <LoadingSpinner size={4} />,
  [CellStatus.QUEUED]: <ClockIcon className="h-4 w-4 cursor-default text-gray-300" />,
  [CellStatus.FAILED]: <XCircleIcon className="h-4 w-4 cursor-default text-red-500" />,
  [CellStatus.LOADING]: <LoadingSpinner size={4} />,
};

export const StatusIndicator = ({
  status,
  icon,
  showTooltip = true,
  tooltipText,
  className = "",
}: StatusIndicatorProps) => {
  const displayIcon = icon || statusIcons[status];
  const displayText = tooltipText || status.charAt(0).toUpperCase() + status.slice(1);

  const content = (
    <div className={`flex h-full justify-center ${className}`}>
      <div className="my-auto">{displayIcon}</div>
    </div>
  );

  if (!showTooltip) {
    return content;
  }

  return (
    <BasicTooltip
      content={displayText}
      className="rounded bg-gray-800 px-2 py-1 text-xs text-white"
    >
      {content}
    </BasicTooltip>
  );
};
